import { Injectable } from '@angular/core';
import {
  Observable,
  throwError
} from 'rxjs';

@Injectable({ providedIn: 'root' })
export class FormsService {
  public isUnique(
    collectionPath: string,
    filedPath: string,
    value: any,
    created: boolean,
  ): Observable<boolean> {
    return throwError('[FormsService::isUnique] Not implements');
  }
}
